import Sample from 'repos/Sample.js';
import {isMobile} from 'react-device-detect';
import {
    setSampleDownloadProgress} from 'actions/index.js';
const TIMEOUT = 6000;

export function getSampleIdsFromSequence(sequence) {
    let samples = [];
    if ('subSequences' in sequence) {
        for (let i in sequence.subSequences) {
            let subSequence = sequence.subSequences[i];
            for (let j in subSequence.tracksData) {
                let trackData = subSequence.tracksData[j];
                samples = samples.concat(Object.keys(trackData.samplers));
            }
        }
    } else {
        for (let j in sequence.tracksData) {
            let trackData = sequence.tracksData[j];
            samples = samples.concat(Object.keys(trackData.samplers));
        }
    }

    return Array.from(new Set(samples));
}

export async function getSamples(sampleIds, encryptedIpfs, sleepTime, engine) {
    let samples = {};

    let a = new Date().getTime();
    
    engine.dispatch(setSampleDownloadProgress(0, sampleIds.length));
    if (isMobile) {
        for (let id of sampleIds) {
            samples[id] = await loadSample(encryptedIpfs, id, engine);
        }
    } else {
   
        let loaders1 = sampleIds.slice(0, 3).map(x => loadSample(encryptedIpfs, x, engine));
        loaders1 = await Promise.all(loaders1);
        let loaders2 = sampleIds.slice(3).map(x => loadSample(encryptedIpfs, x, engine));
        loaders2 = await Promise.all(loaders2);
        let b = new Date().getTime();
        [... loaders1, ...loaders2].forEach(
            x => samples[x.ipfsHash] = x);
    }
    
    return samples;
}


async function sleep(time) {
    return new Promise(async (resolve, reject) => {
        setTimeout(() => {
            resolve();
        }, time)
    });
}

function loadSample(encryptedIpfs, sampleId, engine) {
    return new Promise(async (resolve, reject) => {
        /*
        setTimeout(() => {
            reject();
        }, TIMEOUT);
        */

        let sample = new Sample(sampleId, encryptedIpfs);
        try {
            await sample.load();
            let {downloaded, total} = engine.state.sequencer.sampleDownloadProgress;
            engine.dispatch(setSampleDownloadProgress(downloaded+1, total));
            resolve(sample);
        } catch (e) {
            reject();
        }
    });
}
